/**
 * Маршрут только для права (A7): без него страница не монтируется и её запросы не уходят,
 * вместо неё -- состояние «Недостаточно прав» на том же адресе. Права те же, что у кнопок
 * (usePermissions): учебные команды учебного режима их открывают так же. С детьми охраняет их,
 * без детей -- вложенные маршруты.
 */

import type { ReactNode } from 'react';
import { Outlet } from 'react-router';
import type { Permission } from '@/api/workspaceTypes';
import { usePermissions } from '@/hooks/usePermissions';
import { WorkspaceState } from './WorkspaceState';

interface RequirePermissionProps {
	permission: Permission;
	children?: ReactNode;
}

export function RequirePermission({ permission, children }: RequirePermissionProps) {
	const { has } = usePermissions();
	if (!has(permission)) return <WorkspaceState state="forbidden" />;
	return children ?? <Outlet />;
}
